import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useLocation } from 'react-router-dom';

const CustomCardMobile = ({ cardsToDisplay, stats, loading }) => {
    const isFiveItems = cardsToDisplay.length === 5;

    // Split cards into 3 rows for 5 cards case
    const firstRowItems = cardsToDisplay.slice(0, 2);
    const secondRowItems = cardsToDisplay.slice(2, 4);
    const thirdRowItem = isFiveItems ? cardsToDisplay.slice(4) : [];

    const location = useLocation();
    const isOverviewPage = location.pathname === "/overview";

    return (
        <div>
            {/* First Row */}
            <Row className="px-2 mt-2 gap-3">
                {firstRowItems.map((item, index) => (
                    <Col
                        key={index}
                        className="rounded-4 p-3 d-flex gap-2 flex-column"
                        style={{
                            background: item.label === "Forecasted Budget" ? "var(--color2)" : "var(--color1)",
                            color: item.label === "Forecasted Budget" ? "white" : "var(--color4)",
                        }}
                    >
                        <p className="mb-1 small" style={{ fontSize: '12px' }}>
                            {loading ? (
                                <Skeleton
                                    width={80}
                                    height={20}
                                    baseColor="#ffe521"
                                    highlightColor="#fff899"
                                />
                            ) : (
                                item?.label
                            )}
                        </p>
                        {loading ? (
                            <div className="ps-2">
                                <div className="loader-small"></div>
                            </div>
                        ) : (
                            <>
                                <div className='d-flex align-items-center gap-2'>
                                    <h4 className='mb-0' style={{ fontSize: '16px' }}>{item?.value}</h4>
                                    {(() => {
                                        const change = stats?.comparison?.[item.label]?.change;
                                        const isNegative = typeof change === 'number' && change < 0;
                                        const textColorClass = isNegative ? "text-danger" : "text-success";
                                        const bgColorClass = isNegative ? "bg-light-danger" : "bg-light-success";
                                        return (
                                            <>
                                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                                    <p style={{ fontSize: '12px' }} className="mb-0">
                                                        <span style={{borderRadius:'100px',padding:"2px 7px"}} className={`fw-bold pe-1 ${bgColorClass}`}>
                                                            {change !== undefined ? `${change > 0 ? '+' : ''}${change}%` : "-"}
                                                        </span>{" "}
                                                    </p>
                                                }
                                            </>
                                        );
                                    })()}
                                </div>
                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                    <span style={{ fontSize: '10px' }}>{stats?.comparedTo}</span>
                                }
                            </>
                        )}
                    </Col>
                ))}
            </Row>

            {/* Second Row */}
            <Row className="px-2 mt-4 gap-3">
                {secondRowItems.map((item, index) => (
                    <Col
                        key={index}
                        className="rounded-4 p-3 d-flex gap-2 flex-column"
                        style={{
                            background: item.label === "Forecasted Budget" ? "var(--color2)" : "var(--color1)",
                            color: item.label === "Forecasted Budget" ? "white" : "var(--color4)",
                        }}
                    >
                        <p className="mb-1 small" style={{ color: "var(--color4)", fontSize: '12px' }}>
                            {loading ? (
                                <Skeleton
                                    width={80}
                                    height={20}
                                    baseColor="#ffe521"
                                    highlightColor="#fff899"
                                />
                            ) : (
                                item?.label
                            )}
                        </p>
                        {loading ? (
                            <div className="ps-2">
                                <div className="loader-small"></div>
                            </div>
                        ) : (
                            <>
                                <div className='d-flex align-items-center gap-2'>
                                    <h4 className='mb-0' style={{ fontSize: '16px' }}>{item?.value}</h4>
                                    {(() => {
                                        const change = stats?.comparison?.[item.label]?.change;
                                        const isNegative = typeof change === 'number' && change < 0;
                                        const textColorClass = isNegative ? "text-danger" : "text-success";
                                        const bgColorClass = isNegative ? "bg-light-danger" : "bg-light-success";
                                        return (
                                            <>
                                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                                    <p style={{ fontSize: '12px' }} className="mb-0">
                                                        <span style={{borderRadius:'100px',padding:"2px 7px"}} className={`fw-bold ${bgColorClass}`}>
                                                            {change !== undefined ? `${change > 0 ? '+' : ''}${change}%` : "-"}
                                                        </span>{" "}
                                                    </p>
                                                }
                                            </>
                                        );
                                    })()}
                                </div>
                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                    <span style={{ fontSize: '10px' }}>{stats?.comparedTo}</span>
                                }
                            </>
                        )}
                    </Col>
                ))}
            </Row>

            {/* Third Row for the single card */}
            {isFiveItems && thirdRowItem.length > 0 && (
                <Row className="px-2 mt-4 gap-3 justify-content-center">
                    <Col
                        key={thirdRowItem[0].label}
                        // xs={6}
                        className="rounded-4 p-3"
                        style={{
                            background: thirdRowItem[0].label === "Forecasted Budget" ? "var(--color2)" : "var(--color1)",
                            color: thirdRowItem[0].label === "Forecasted Budget" ? "white" : "var(--color4)",
                        }}
                    >
                        <div>
                            <p className="mb-1 small" style={{ fontSize: '12px' }}>
                                {loading ? (
                                    <Skeleton
                                        width={80}
                                        height={20}
                                        baseColor="#ffe521"
                                        highlightColor="#fff899"
                                    />
                                ) : (
                                    thirdRowItem[0]?.label
                                )}
                            </p>
                            {loading ? (
                                <div className="ps-2">
                                    <div className="loader-small"></div>
                                </div>
                            ) : (
                                <>
                                    <div className='d-flex align-items-center'>
                                        <h4 style={{ fontSize: '16px' }}>{thirdRowItem[0]?.value}</h4>
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default CustomCardMobile;
